const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen pt-24 px-4 bg-[#0A0A0A]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold font-['Space_Grotesk'] text-[#F4F1DE] mb-8">
          Privacy Policy
        </h1>
        
        <div className="bg-[#121212] border border-white/10 p-8 space-y-8">
          <p className="text-[#F4F1DE]/60 text-sm">
            Last updated: December 2025
          </p>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">1. Introduction</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              ReptiCraft ("we", "our", or "us") is committed to protecting your privacy. This Privacy 
              Policy explains how we collect, use, disclose, and safeguard your information when you 
              visit our website and use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">2. Information We Collect</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p><strong className="text-[#F4F1DE]">Personal Information:</strong> When you create an account or place an order, we collect:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name and contact details (email, phone number)</li>
                <li>Delivery address</li>
                <li>Payment information (processed securely via Stripe)</li>
                <li>Order history and saved configurations</li>
              </ul>
              <p><strong className="text-[#F4F1DE]">Automatically Collected Information:</strong></p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Browser type and version</li>
                <li>Device information</li>
                <li>IP address</li>
                <li>Pages visited and time spent on our site</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">3. How We Use Your Information</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed">
              <p className="mb-4">We use your information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Process and fulfill your orders</li>
                <li>Communicate about your order status</li>
                <li>Provide customer support</li>
                <li>Send promotional emails (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Prevent fraud and ensure security</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">4. Data Sharing</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>We do not sell your personal information. We may share your data with:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-[#F4F1DE]">Payment Processors:</strong> Stripe processes payments securely. We never store your full card details.</li>
                <li><strong className="text-[#F4F1DE]">Delivery Partners:</strong> Courier services receive your delivery address to fulfill orders.</li>
                <li><strong className="text-[#F4F1DE]">Service Providers:</strong> Third parties who help us operate our business (hosting, analytics).</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">5. Cookies</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>We use cookies to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Keep you logged in</li>
                <li>Remember your cart contents</li>
                <li>Understand how you use our site</li>
              </ul>
              <p>
                You can disable cookies in your browser settings, but some features may not work correctly.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">6. Your Rights (GDPR)</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed space-y-4">
              <p>Under GDPR, you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-[#F4F1DE]">Access:</strong> Request a copy of your personal data</li>
                <li><strong className="text-[#F4F1DE]">Rectification:</strong> Correct inaccurate information</li>
                <li><strong className="text-[#F4F1DE]">Erasure:</strong> Request deletion of your data ("right to be forgotten")</li>
                <li><strong className="text-[#F4F1DE]">Portability:</strong> Receive your data in a portable format</li>
                <li><strong className="text-[#F4F1DE]">Object:</strong> Object to certain processing of your data</li>
                <li><strong className="text-[#F4F1DE]">Withdraw Consent:</strong> Opt out of marketing communications</li>
              </ul>
              <p>
                To exercise these rights, contact us at{" "}
                <a href="mailto:repticraftstore@gmail.com" className="text-[#E07A5F] hover:underline">
                  repticraftstore@gmail.com
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">7. Data Retention</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              We retain your personal data for as long as necessary to provide our services and comply 
              with legal obligations. Order records are kept for 7 years for tax purposes. You can 
              request deletion of your account at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">8. Security</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              We implement industry-standard security measures including encryption, secure servers, 
              and regular security audits. However, no method of transmission over the Internet is 
              100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">9. Changes to This Policy</h2>
            <p className="text-[#F4F1DE]/80 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any material 
              changes by posting the new policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#F4F1DE] mb-4">10. Contact Us</h2>
            <div className="text-[#F4F1DE]/80 leading-relaxed">
              <p>For privacy-related questions or to exercise your rights, contact us at:</p>
              <p className="mt-4">
                <strong className="text-[#F4F1DE]">Email:</strong>{" "}
                <a href="mailto:repticraftstore@gmail.com" className="text-[#E07A5F] hover:underline">
                  repticraftstore@gmail.com
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
